import type { ChatCardChoice } from "@/features/portfolio-analysis/lib/chat-card-choice";
import type { ClientSeed } from "@/features/advice-portal/workspace/record-panel/picker/seeded-client";
import { settledWithin } from "@/shared/time/settled-within";

export async function cardChoice(
  seed: ClientSeed & { portfolioQuery?: string | null },
  withPortfolio: boolean,
  toolCallId: string | null = null,
  load: () => Promise<ChoiceModule> = loadChoice,
  waitMs: number = CARD_CHOICE_WAIT_MS,
): Promise<ChatCardChoice> {
  if (!seed.clientId?.trim() && !seed.clientQuery?.trim()) return { kind: "asks", step: "client" };
  const started = Date.now();
  const choice = await settledWithin(load(), waitMs);
  if (choice === "late" || choice === "failed") return { kind: "finding", step: "client" };
  return choice.chatCardChoice(seed, withPortfolio, waitMs - (Date.now() - started), toolCallId);
}

function loadChoice(): Promise<ChoiceModule> {
  return import("@/features/portfolio-analysis/lib/chat-card-choice");
}

type ChoiceModule = typeof import("@/features/portfolio-analysis/lib/chat-card-choice");

const CARD_CHOICE_WAIT_MS = 2_500;
